import React from 'react'

// styles
import * as SC from './NpForBusinessSectionStyles'
import { HomePageContainer } from '../../HomePageStyles'
import { BREAKPOINTS_INTS } from '../../../../styles/constants'

// types
import { CmsHomepageData } from '../../../../types/types'

type Props = {
	cmsData: CmsHomepageData['npForBusinessData']
}

// component
const NpForBusiness = (props: Props) => {
	const { cmsData } = props
	const { image, backgroundImage, backgroundImageWebP } = cmsData

	const picture = (
		<SC.Picture>
			{/* WebP variants */}
			{image.desktopWebP && (
				<source srcSet={image.desktopWebP} type='image/webp' media={`(min-width: ${BREAKPOINTS_INTS.md}px)`} width={1280} height={460} />
			)}
			{image.mobileWebP && (
				<source srcSet={image.mobileWebP} type='image/webp' media={`(max-width: ${BREAKPOINTS_INTS.md - 1}px)`} width={772} height={332} />
			)}

			{/* JPEG fallback */}
			<source srcSet={image.desktop} media={`(min-width: ${BREAKPOINTS_INTS.md}px)`} width={1280} height={460} />
			<source srcSet={image.mobile} media={`(max-width: ${BREAKPOINTS_INTS.md - 1}px)`} width={772} height={332} />

			{/* Fallback <img> tag for maximum compatibility */}
			<img src={image.desktop} alt={image.alt} loading='lazy' width={1280} height={460} />
		</SC.Picture>
	)

	return (
		<SC.Section $backgroundImage={backgroundImage} $backgroundImageWebP={backgroundImageWebP}>
			<HomePageContainer>
				{image.link ? (
					<SC.Link href={image.link} target='_blank' rel={'noopener noreferrer'}>
						{picture}
					</SC.Link>
				) : (
					picture
				)}
			</HomePageContainer>
		</SC.Section>
	)
}

export default NpForBusiness
